// import { createSelector } from 'reselect'

const getState = state => state.global

const carriersSelector = state => getState(state).carriers
const busesSelector = state => getState(state).buses
const driversSelector = state => getState(state).drivers

export {
  busesSelector,
  driversSelector,
  carriersSelector,
}


// WEBPACK FOOTER //
// ./src/reduxModules/selectors/GlobalSelectors.js